/**
 * Announcement API สำหรับ user-classic — เรียก tenant-management announcements (target=user-classic)
 */
import {
  fetchActiveAnnouncementsCached,
  invalidateAnnouncementCache,
  type Announcement,
} from '@huay/shared/tenantManagementPublicClient'
import { withApiBaseUrl } from '../lib/apiBaseUrl'

export type AnnouncementPriority = 'urgent' | 'general' | 'warning'
export type { Announcement }

function getApiBaseUrl(): string {
  const sample = withApiBaseUrl('/api/v1/tenant-management/maintenance')
  return sample.replace(/\/api\/v1\/tenant-management\/maintenance$/, '')
}

export const announcementService = {
  async getActive(
    tenantId: string,
    username?: string | null,
    options?: { bypassCache?: boolean }
  ): Promise<{ success: boolean; data: Announcement[] }> {
    return fetchActiveAnnouncementsCached(
      getApiBaseUrl(),
      tenantId,
      'user-classic',
      username,
      options
    )
  },

  invalidateCache(tenantId: string, username?: string | null): void {
    invalidateAnnouncementCache(tenantId, 'user-classic', username)
  },

  async acknowledge(
    announcementId: string,
    tenantId: string,
    payload?: { userId?: string; sessionId?: string; clientFingerprint?: string }
  ): Promise<{ success: boolean }> {
    const path = `/api/v1/tenant-management/announcements/${announcementId}/ack`
    const url = withApiBaseUrl(path)
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Tenant-ID': tenantId },
      body: JSON.stringify({ tenantId, target: 'user-classic', ...payload }),
    })
    const json = await res.json()
    return json as { success: boolean }
  },
}
